module.exports = __webpack_public_path__ + "static/media/solution01@2x.e50ccb2f.png";